import { Livewire, Alpine } from '../../../../../../../../vendor/livewire/livewire/dist/livewire.esm';
import Clipboard from '@ryangjchandler/alpine-clipboard'

Alpine.plugin(Clipboard)
Livewire.start()

// Swiper
import Swiper from 'swiper';
import { Navigation, Pagination, Grid, Autoplay, Thumbs, EffectCards, EffectCoverflow, EffectFlip } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-coverflow';
import 'swiper/css/grid';
import 'swiper/css/autoplay';
import 'swiper/css/thumbs';
import 'swiper/css/effect-cards';
import 'swiper/css/effect-flip';

// Initialize Swiper modules
Swiper.use([Navigation, Pagination, Grid, Autoplay, Thumbs, EffectCards, EffectCoverflow, EffectFlip]);

// Export for global use if needed
window.Swiper = Swiper

// Swal
import Swal from 'sweetalert2';
window.Swal = Swal;
window.Toast = Swal.mixin({
    toast: true,
    position: 'top-right',
    iconColor: 'white',
    customClass: {
        popup: 'colored-toast'
    },
    showConfirmButton: false,
    timer: 3330,
    timerProgressBar: true
});

// Lazyload
import lazySizes from 'lazysizes';

// fslightbox
import FsLightbox from "fslightbox";

// Fancybox
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

// PURECOUNTER
import PureCounter from "@srexi/purecounterjs";

const setupApp = ()=>
{
    lazySizes.init();
    refreshFsLightbox();

    // Fancybox
    Fancybox.bind("[data-fancybox]", {
        // Your custom options
    });

    const pure = new PureCounter({
        formater: "fa-Fa",
    });

    let heroSwiper = new Swiper("#heroSwiper", {
        modules: [Navigation,EffectCards,Autoplay],
        slidesPerView: 1,
        loop: true,
        spaceBetween: 5,
        effect: 'cards',
        cardsEffect: {
            perSlideOffset: 3,
            perSlideRotate: 8,
            rotate: true,
            slideShadows:false,

        },
        breakpoints: {
            480: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 1,
            },
            1024: {
                cardsEffect: {
                    perSlideOffset: 3,
                    perSlideRotate: 4,
                    rotate: true,
                    slideShadows:false,
                },
                slidesPerView: 1,
            },
            1280: {
                cardsEffect: {
                    perSlideOffset: 3,
                    perSlideRotate: 4,
                    rotate: true,
                    slideShadows:false,
                },
                spaceBetween: 5,
                slidesPerView: 1,
            },
        },
        autoplay: {
            delay: 2500,
            disableOnInteraction: false,
        },
        navigation: {
            nextEl: ".heroSwiperNext",
            prevEl: ".heroSwiperPrev",
        },
    });


    let specialCategoriesSwiper = new Swiper("#specialCategoriesSwiper", {
        slidesPerView: 1.5,
        loop: true,
        spaceBetween: 10,
        breakpoints: {
            480: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 3,
            },
            1024: {
                slidesPerView: 4,
            },
            1280: {
                spaceBetween: 14,
                slidesPerView: 4.4,
            },
        },
    });


    let specialCategoriesSwiper2 = new Swiper("#specialCategoriesSwiper2", {
        slidesPerView: 1.5,
        loop: true,
        spaceBetween: 10,
        breakpoints: {
            480: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 3,
            },
            1024: {
                slidesPerView: 4,
            },
            1280: {
                spaceBetween: 14,
                slidesPerView: 4.4,
            },
        },
    });

    let sizeSeparationSwiper = new Swiper("#sizeSeparationSwiper", {
        modules: [Navigation, Grid],
        slidesPerView: 2,
        grid: {
            rows: 2,
            fill: 'row'
        },
        spaceBetween: 10,
        breakpoints: {
            480: {
                slidesPerView:2,
            },
            768: {
                slidesPerView: 3,
                grid: {
                    rows: 1,
                    fill: 'row'
                },
            },
            1024: {
                slidesPerView: 3.5,
                grid: {
                    rows: 1,
                    fill: 'row'
                },
            },
            1280: {
                spaceBetween: 14,
                slidesPerView: 4,
                grid: {
                    rows: 1,
                    fill: 'row'
                },
            },
        },
        navigation: {
            nextEl: "#sizeSeparationSwiperrPrev",
            prevEl: "#sizeSeparationSwiperrNext",
        },
    });

    let blogSwiper2 = new Swiper("#blogSwiper", {
        slidesPerView: 1.5,
        loop: true,
        spaceBetween: 10,
        breakpoints: {
            480: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 3,
            },
            1024: {
                slidesPerView: 4,
            },
            1280: {
                spaceBetween: 14,
                slidesPerView: 4.4,
            },
        },
    });

    let aboutHeroSwiper = new Swiper("#aboutHeroSwiper", {
        modules: [Navigation, Autoplay, EffectFlip],
        slidesPerView: 1,
        loop: true,
        effect: "flip",
        spaceBetween: 5,
        breakpoints: {
            480: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 1,
            },
            1024: {
                cardsEffect: {
                    perSlideOffset: 3,
                    perSlideRotate: 4,
                    rotate: true,
                    slideShadows:false,
                },
                slidesPerView: 1,
            },
            1280: {
                cardsEffect: {
                    perSlideOffset: 3,
                    perSlideRotate: 4,
                    rotate: true,
                    slideShadows:false,
                },
                spaceBetween: 5,
                slidesPerView: 1,
            },
        },
        autoplay: {
            delay: 2500,
            disableOnInteraction: false,
        },
        navigation: {
            nextEl: "#aboutHeroSwiperNext",
            prevEl: "#aboutHeroSwiperPrev",
        },
    });

    let aboutCertificatesSwiper = new Swiper("#aboutCertificatesSwiper", {
        modules: [Navigation, EffectCoverflow],
        slidesPerView: 1.5,
        spaceBetween: 10,
        loop: true,
        centeredSlides: true,
        effect: "coverflow",
        coverflowEffect: {
            rotate: 30,
            depth: 50,
            slideShadows: false,
        },
        breakpoints: {
            480: {
                slidesPerView:2,
            },
            768: {
                slidesPerView: 3,
            },
            1024: {
                slidesPerView: 3.5,
            },
            1280: {
                slidesPerView: 4,
            },
        },
        navigation: {
            nextEl: "#aboutCertificatesSwiperrNext",
            prevEl: "#aboutCertificatesSwiperrPrev",
        },
    });

    let productGalleryThumb = new Swiper('.product-thumb-imgs-swiper-container', {
        modules: [Navigation],
        direction: 'horizontal',
        spaceBetween: 10,
        slidesPerView: 3,
        breakpoints: {
            768:{
                slidesPerView: 4,
            },
        },
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
    });

    let productGallery = new Swiper('.product-imgs-swiper-container', {
        modules: [Navigation, Thumbs],
        direction: 'horizontal',
        centeredSlides:true,
        centeredSlidesBounds:true,
        slidesPerView:1,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        spaceBetween: 10,
        thumbs: {
            swiper : productGalleryThumb
        },
    });

    let productRelatedItems = new Swiper('.product-related-items',  {
        slidesPerView: 1.2,
        spaceBetween: 15,
        breakpoints:{
            768:{
                slidesPerView: 2.3,
            },
            1024: {
                slidesPerView:3.3,
            },
            1280:{
                slidesPerView:4.3,
            },
        }
    });

};

["livewire:initialized", "livewire:navigated", "resize", "pageChanged"].forEach((event) => {
    window.addEventListener(event, setupApp)
})

window.addEventListener('scroll', () => {
    const rug = document.getElementById('rug');
    const triggerPoint = rug.getBoundingClientRect().top;
    const windowHeight = window.innerHeight;

    if (triggerPoint < windowHeight - 100) {
        rug.classList.add('show');
    }
});

